'use client';

import React from 'react';
import Image from 'next/image';
import { useAppDispatch, useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';
import { toggleClosedCaptions } from 'slices/mediaSlice';
import { ANALYTICS_EVENTS, capture } from 'lib/analytics';

import styles from './TopNavBar.module.scss';

const ClosedCaptionsButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showClosedCaptions } = useAppSelector(
    (state: RootState) => state.media
  );

  const handleClick = () => {
    if (!showClosedCaptions) capture(ANALYTICS_EVENTS.closedCaptionsEnabled);
    dispatch(toggleClosedCaptions());
  };

  const getClosedCaptionsIcon = () => {
    return showClosedCaptions
      ? '/ClosedCaptioning-Enabled.svg'
      : '/ClosedCaptioning-Disabled.svg';
  };

  return (
    <button className={styles.iconButton} onClick={handleClick}>
      <Image
        src={getClosedCaptionsIcon()}
        alt="Closed Caption"
        width={24}
        height={24}
      />
    </button>
  );
};

export default ClosedCaptionsButton;
